// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"4241b0e8","531":"1d7d15e8","986":"6161d27f"}[chunkId] + ".chunk.js";
};